import React from "react";
import "semantic-ui-css/semantic.min.css";
import "./_App.scss";
import {
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { hot } from 'react-hot-loader/root';
import { ModalController } from "controls/modals";
import { ErrorBoundary } from "components/common";
import LoginForm from "components/Authentication/LoginForm/LoginForm";
import Account from "components/User/Account/Account";
import ForgotPassword from "components/Authentication/ForgotPassword/ForgotPassword";
import SignUpForm from "components/Authentication/SignUpForm/SignUpForm";
import RenewSubscription from "components/User/RenewSubscription/RenewSubscription";

export const App = hot(() => {
  const modals = useSelector((state) => state.modals);
  const userInfo = useSelector((state) => state.userInfo);

  return (
    <div className="App">
      <link
        rel="stylesheet"
        href="https://unpkg.com/tachyons@4/css/tachyons.min.css"
      />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        rel="stylesheet"
      ></link>
      <ErrorBoundary>
        <Switch>
          <Route path="/forgot" component={ForgotPassword} />
          <Route path="/signup" component={SignUpForm} />
          {userInfo ? (
            <Redirect to="/details" from="/login" />
          ) : (
            <Route exact path="/login" component={LoginForm} />
          )}
          {!userInfo && <Redirect to="/login" />}
          <Redirect exact from="/" to="/login" />
          {userInfo 
            && (
              <>
                <Route exact path="/details" component={Account} />
                <Route exact path="/renew" component={RenewSubscription} />
              </>
            )}
        </Switch>
      </ErrorBoundary>
      <ModalController modals={modals} />
    </div>
  );
});
